import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_BUDGETS_PERCENTAGE, 
  ADD_NEW_BUDGET_PERCENTAGE,
  UPDATE_BUDGET_PERCENTAGE,
  DELETE_BUDGET_PERCENTAGE
 } from "./actionTypes";
import {
  getBudgets_percentageSuccess,
  getBudgets_percentageFail,
  addBudget_percentageSuccess,
  addBudget_percentageFail,
  updateBudget_percentageSuccess,
  updateBudget_percentageFail,
  deleteBudget_percentageSuccess,
  deleteBudget_percentageFail,
} from "./actions"
 
//Include Both Helper File with needed methods
import { 
  getBudgets_percentage,
  // getCeremonyProfile,
  addNewBudget_percentage,
  updateBudget_percentage,
  deleteBudget_percentage,
} from "../../helpers/backend_helper";
import { showPopup } from "../popup/actions"

function* fetchCeremonies({payload}) {
  try {
    const response = yield call(getBudgets_percentage,payload);
    yield put(getBudgets_percentageSuccess(response));
  } catch (error) {
    yield put(getBudgets_percentageFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onUpdateCeremony ({payload: ceremony }) {
  try {
   let response = yield call(updateBudget_percentage, ceremony);
   if(response.file_src || ceremony.removeImage) ceremony.image = response.file_src
 yield put(updateBudget_percentageSuccess(ceremony));
    yield put(showPopup({ title: response.message, success: true }));
    
  } catch (error) {
    yield put(updateBudget_percentageFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onDeleteCeremony({ payload: ceremony }) {
  
  try {
    let response =  yield call(deleteBudget_percentage, ceremony);
    yield put(deleteBudget_percentageSuccess(ceremony));
    yield put(showPopup({title:response.message,success:true}));
  } catch (error) {
    yield put(deleteBudget_percentageFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onAddNewCeremony({ payload: ceremony }) {
  try {
   let response = yield call(addNewBudget_percentage, ceremony);
    yield put(addBudget_percentageSuccess(response.data));
    yield put(showPopup({title:response.message,success:true}));
  } catch (error) {
    yield put(addBudget_percentageFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));
  }
}


// function* fetchCeremonyProfile() {
//   try {
//     const response = yield call(getCeremonyProfile);
//     yield put(getCeremonyProfileSuccess(response));
//   } catch (error) {
//     yield put(getCeremonyProfileFail(error));
//   }
// }

function* ceremonysSaga() {
  yield takeEvery(GET_BUDGETS_PERCENTAGE, fetchCeremonies);
  yield takeEvery(ADD_NEW_BUDGET_PERCENTAGE, onAddNewCeremony);
  yield takeEvery(UPDATE_BUDGET_PERCENTAGE, onUpdateCeremony);
  yield takeEvery(DELETE_BUDGET_PERCENTAGE, onDeleteCeremony);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchCeremonyProfile);
}

export default ceremonysSaga;
